<kendo-expansionpanel [title]="'Offers'"
                      [subtitle]="''"
                      [expanded]="carrierContract.masterOfferID == null">
    <div class="row" *ngIf="isAddOffer">
        <div class="col">
            <div class="k-float-right">
                <button type="button" class="btn btn-secondary" (click)="isAddOffer = false"><i class="fas fa-times"></i></button>
            </div>
            <carrier-list-grid [quoteOrderLineID]="masterQuoteOrderLineID"
                               [viewType]="'contract'"
                               (updateEditedLoad)="isAddOffer = false">
            </carrier-list-grid>
        </div>
    </div>
    <div class="row" *ngIf="!isAddOffer">
        <div class="col">
            <div class="k-float-right">
                <button type="button" class="btn btn-primary" (click)="isAddOffer = true"><i class="fas fa-plus"></i></button>
            </div>
            <carrier-offer-grid [quoteOrderLineID]="masterQuoteOrderLineID" [viewType]="'contract'" (onSetContractClick)="setContract($event)"></carrier-offer-grid>
        </div>
    </div>
</kendo-expansionpanel>

<kendo-expansionpanel [title]="'Contract Detail'"
                      [subtitle]="''"
                      [expanded]="true"
                      *ngIf="carrierContract.masterOfferID > 0">
    <div class="row">
        <!-- Carrier contact, drivers, truck, trailer -->
        <div class="col-sm-4">
            <h3 class="text-center">Carrier Info</h3>
            <div class="row p-1">
                <div class="col-sm-4 fw-bold text-end">
                    Carrier
                </div>
                <div class="col-sm-8">
                    <rmis-status [rmisStatusColor]="offer.rmisStatusColor" [rmisStatusTextColor]="offer.rmisStatusTextColor" [rmisStatusAbbrev]="offer.rmisStatusAbbrev" [rmisStatusTooltip]="offer.nonCertifiedReasons"></rmis-status>
                    <a target="_blank" [routerLink]="['/carrier-detail', offer.carrierCode]">
                        {{offer.carrierName}}<br />
                        {{offer.carrierCode}}
                    </a>
                </div>
            </div>
            <div class="row p-1">
                <div class="col-sm-4 fw-bold text-end">
                    Contact
                </div>
                <div class="col-sm-6">
                    <select name="contactID" [(ngModel)]="quoteOrderLine.carrierContactId" class="form-select" (change)="contactChange($event)">
                        <option value=""></option>
                        <option *ngFor="let contact of contacts" value="{{contact.contactID}}">{{contact.contactName}}</option>
                    </select>
                </div>
                <div class="col-sm-1">
                    <button (click)="addContact('Dispatcher')" class="btn btn-sml btn-primary" title="Add Contact"><i class="fas fa-plus"></i></button>
                </div>
                <div class="col-sm-1">
                    <button (click)="editContact('Dispatcher')" class="btn btn-sml btn-success" title="Edit Contact" *ngIf="quoteOrderLine.carrierContactId>0"><i class="fas fa-pencil-alt"></i></button>
                </div>
            </div>
            <div class="row p-1" *ngIf="isAddDispatcher">
                <div class="col-sm-12 border border-primary bg-light m-2 p-2">
                    <contact-quick-add [tableID]="offer.carrierID" [contactTitleID]="2" [contactType]="'Carrier'" [countryCode]="countryCode" (onRefreshContact)="refreshContacts($event, 'Dispatcher')"></contact-quick-add>
                </div>
            </div>
            <div class="row p-1" *ngIf="isEditDispatcher">
                <div class="col-sm-12 border border-primary bg-light m-2 p-2">
                    <contact-quick-edit [contactID]="quoteOrderLine.carrierContactId" (onRefreshContact)="refreshContacts($event, 'Dispatcher')"></contact-quick-edit>
                </div>
            </div>
            <div class="row p-1">
                <div class="col-sm-4 fw-bold text-end">
                    Phone
                </div>
                <div class="col-sm-8">
                    <div *ngIf="selectedContact.cell != '' && selectedContact.cell != null || selectedContact.phone != '' && selectedContact.phone != null">
                        <!--<kendo-maskedtextbox [mask]="phoneMask" class="form-control" type="text" [(ngModel)]="selectedContact.phone" [disabled]="true"></kendo-maskedtextbox>-->
                        <a href="tel:{{selectedContact.cell}}" *ngIf="selectedContact.cell != '' && selectedContact.cell != null">{{selectedContact.cellCountryAbbrev != null && selectedContact.cellCountryAbbrev != '' ? (selectedContact.cell | phone:selectedContact.cellCountryAbbrev.trim()) : (selectedContact.cell | phone:'US')}}</a>
                        <a href="tel:{{selectedContact.phone}}" *ngIf="selectedContact.cell == '' || selectedContact.cell == null">{{selectedContact.phoneCountryAbbrev != null && selectedContact.phoneCountryAbbrev != '' ? (selectedContact.phone | phone:selectedContact.phoneCountryAbbrev.trim()) : (selectedContact.phone | phone:'US')}}</a>
                    </div>
                </div>
            </div>
            <div class="row p-1">
                <div class="col-sm-4 fw-bold text-end">
                    Email
                </div>
                <div class="col-sm-8">
                    <input class="form-control" [ngClass]="(selectedContact.email==null||selectedContact.email=='') ? 'border border-danger' : ''" type="text" [(ngModel)]="selectedContact.email" [disabled]="true" [required]="true" />
                    <!--<span *ngIf="selectedContact.email==null||selectedContact.email==''" class="fw-bold text-end text-danger"><i class="fas fa-times-circle"></i></span>-->
                </div>
            </div>
            <div class="row p-1">
                <div class="col-sm-4 fw-bold text-end">
                    Driver 1
                </div>
                <div class="col-sm-6">
                    <select name="driverID" [(ngModel)]="quoteOrderLine.driverId" class="form-select" (change)="driverChange($event, 1)">
                        <option value=""></option>
                        <option *ngFor="let driver of drivers" value="{{driver.contactID}}">{{driver.contactName}}</option>
                    </select>
                </div>
                <div class="col-sm-1">
                    <button (click)="addContact('Driver1')" class="btn btn-sml btn-primary" title="Add Driver"><i class="fas fa-plus"></i></button>
                </div>
                <div class="col-sm-1">
                    <button (click)="editContact('Driver1')" class="btn btn-sml btn-success" title="Edit Driver" *ngIf="quoteOrderLine.driverId>0"><i class="fas fa-pencil-alt"></i></button>
                </div>
            </div>
            <div class="row p-1" *ngIf="isAddDriver1">
                <div class="col-sm-12 border border-primary bg-light m-2 p-2">
                    <contact-quick-add [tableID]="offer.carrierID" [contactTitleID]="3" [contactType]="'Carrier'" [countryCode]="countryCode" (onRefreshContact)="refreshContacts($event, 'Driver1')"></contact-quick-add>
                </div>
            </div>
            <div class="row p-1" *ngIf="isEditDriver1">
                <div class="col-sm-12 border border-primary bg-light m-2 p-2">
                    <contact-quick-edit [contactID]="quoteOrderLine.driverId" (onRefreshContact)="refreshContacts($event, 'Driver1')"></contact-quick-edit>
                </div>
            </div>
            <div class="row p-1">
                <div class="col-sm-4 fw-bold text-end">
                    Driver 1 Cell
                </div>
                <div class="col-sm-8">
                    <a href="tel:{{selectedDriver.cell}}">{{selectedDriver.cellCountryAbbrev != null && selectedDriver.cellCountryAbbrev != '' ? (selectedDriver.cell | phone:selectedDriver.cellCountryAbbrev.trim()) : (selectedDriver.cell | phone:'US')}}</a>
                </div>
            </div>
            <div class="row p-1">
                <div class="col-sm-4 fw-bold text-end">
                    Driver 2
                </div>
                <div class="col-sm-6">
                    <select name="driver2ID" [(ngModel)]="quoteOrderLine.driver2Id" class="form-select" (change)="driverChange($event, 1)">
                        <option value=""></option>
                        <option *ngFor="let driver of drivers" value="{{driver.contactID}}">{{driver.contactName}}</option>
                    </select>
                </div>
                <div class="col-sm-1">
                    <button (click)="addContact('Driver2')" class="btn btn-sml btn-primary" title="Add Driver"><i class="fas fa-plus"></i></button>
                </div>
                <div class="col-sm-1">
                    <button (click)="editContact('Driver2')" class="btn btn-sml btn-success" title="Edit Driver" *ngIf="quoteOrderLine.driver2Id>0"><i class="fas fa-pencil-alt"></i></button>
                </div>
            </div>
            <div class="row p-1" *ngIf="isAddDriver2">
                <div class="col-sm-12 border border-primary bg-light m-2 p-2">
                    <contact-quick-add [tableID]="offer.carrierID" [contactTitleID]="3" [contactType]="'Carrier'" [countryCode]="countryCode" (onRefreshContact)="refreshContacts($event, 'Driver2')"></contact-quick-add>
                </div>
            </div>
            <div class="row p-1" *ngIf="isEditDriver2">
                <div class="col-sm-12 border border-primary bg-light m-2 p-2">
                    <contact-quick-edit [contactID]="quoteOrderLine.driver2Id" (onRefreshContact)="refreshContacts($event, 'Driver2')"></contact-quick-edit>
                </div>
            </div>
            <div class="row p-1">
                <div class="col-sm-4 fw-bold text-end">
                    Driver 2 Cell
                </div>
                <div class="col-sm-8">
                    <a href="tel:{{selectedDriver2.cell}}">{{selectedDriver2.cellCountryAbbrev != null && selectedDriver2.cellCountryAbbrev != '' ? (selectedDriver2.cell | phone:selectedDriver2.cellCountryAbbrev.trim()) : (selectedDriver2.cell | phone:'US')}}</a>
                </div>
            </div>
            <div class="row p-1" *ngIf="macropointLocationProviderDevice != 'VehicleID'">
                <div class="col-sm-4 fw-bold text-end">
                    Truck #
                </div>
                <div class="col-sm-8">
                    <input class="form-control" type="text" [(ngModel)]="quoteOrderLine.truckNumber"
                           [ngClass]="(macropointLocationProviderDevice == 'VehicleID' && (quoteOrderLine.truckNumber == '' || quoteOrderLine.truckNumber == null)) ? 'border border-danger' : ''"
                           [required]="macropointLocationProviderDevice == 'VehicleID'" (change)="validate(false)"
                           [disabled]="macropointLocationProviderDevice=='VehicleID'" />
                </div>
            </div>
            <div class="row p-1">
                <div class="col-sm-4 fw-bold text-end">
                    Trailer #
                </div>
                <div class="col-sm-8">
                    <input class="form-control" type="text" [(ngModel)]="quoteOrderLine.trailerNumber"
                           [ngClass]="(macropointLocationProviderDevice == 'TrailerID' && (quoteOrderLine.trailerNumber == '' || quoteOrderLine.trailerNumber == null)) ? 'border border-danger' : ''"
                           [required]="macropointLocationProviderDevice == 'TrailerID'" (change)="validate(false)" />
                </div>
            </div>
        </div>
        <!-- Carrier Rep and Contract info -->
        <div class="col-sm-4">
            <h3 class="text-center">Settlement Info</h3>
            <div class="row p-1">
                <div class="col-sm-4 fw-bold text-end">
                    PPC City
                </div>
                <div class="col-sm-8">
                    <city-state-zip-dropdown [parentForm]="carrierContractForm" [ctrlName]="'ppcCityStateZipCtrl'" [placeholder]="'Select a City'"
                                             (citySelected)="ppcCitySTChanged($event, false)" [defaultCity]="defaultPPCCity"
                                             [cityID]="carrierContract.ppcCityID" [isChooseDefaultZip]="true"
                                             [isRequired]="true"></city-state-zip-dropdown>
                </div>
            </div>
            <div class="row p-1">
                <div class="col-sm-4 fw-bold text-end">
                    Rate
                </div>
                <div class="col-sm-8">
                    <input type="number" class="form-control" [(ngModel)]="carrierContract.offerRate" (change)="calcRate('offerRate')" min="0" step="0.01" required />
                </div>
            </div>
            <div class="row p-1">
                <div class="col-sm-4 fw-bold text-end">
                    Rate/mi
                </div>
                <div class="col-sm-8">
                    <input type="number" class="form-control" [(ngModel)]="carrierContract.offerRatePerMile" (change)="calcRate('offerRatePerMile')" min="0" step="0.01" required />
                </div>
            </div>
            <div class="row p-1">
                <div class="col-sm-4 fw-bold text-end">
                    Carrier Rep
                </div>
                <div class="col-sm-8">
                    <select name="awardedCarrierRepId" [(ngModel)]="quoteOrderLine.awardedCarrierRepId" class="form-select" (change)="validate(false)" required>
                        <option *ngFor="let rep of carrierReps" value="{{rep.employeeId}}">{{rep.fullName}}</option>
                    </select>
                </div>
            </div>
            <div class="row p-1">
                <div class="col-sm-4 fw-bold text-end">
                    CSR Team
                </div>
                <div class="col-sm-8">
                    <kendo-multiselect [data]="carrierReps"
                                       textField="fullName"
                                       valueField="employeeId"
                                       [autoClose]="false"
                                       [valuePrimitive]="true"
                                       style="width:235px;height:33.5px;"
                                       [value]="carrierRepsFilter"
                                       (valueChange)="carrierRepsChange($event)">
                    </kendo-multiselect>
                    <!--[value]="carrierRepsFilters(filter)"-->
                </div>
            </div>
            <h3 class="text-center">Contract Date Range</h3>
            <div class="row p-1">
                <div class="col-sm-4 fw-bold text-end">
                    Start
                </div>
                <div class="col-sm-8">
                    <kendo-datepicker name="startDate" [(ngModel)]="carrierContract.startDate" [format]="'MM/dd/yyyy'" (valueChange)="dateChanged('startDate')" [ngModelOptions]="{standalone: true}" required>
                    </kendo-datepicker>
                </div>
            </div>
            <div class="row p-1">
                <div class="col-sm-4 fw-bold text-end">
                    Expiration
                </div>
                <div class="col-sm-8">
                    <kendo-datepicker name="expirationDate" [(ngModel)]="carrierContract.expirationDate" [format]="'MM/dd/yyyy'" (valueChange)="dateChanged('expirationDate')" required>
                    </kendo-datepicker>
                </div>
            </div>
            <div class="row p-1">
                <div class="col-sm-4 fw-bold text-end">
                    Expired
                </div>
                <div class="col-sm-8">
                    <input type="checkbox" name="isExpired" id="isExpired" style="cursor: pointer;margin: 10px; transform: scale(1.5);" [(ngModel)]="carrierContract.isExpired" />
                </div>
            </div>
        </div>
        <!-- Macropoint -->
        <!--<div class="col-sm-4" *ngIf="quoteOrderLine.isMacropointRequired == true">-->
        <div class="col-sm-4">
            <h3 class="text-center">Macropoint
            <!--<span class="text-danger" *ngIf="quoteOrderLine.isMacropointRequired == true">REQUIRED</span>-->
            </h3>
            <div class="row p-1">
                <div class="col-sm-4 fw-bold text-end">
                    Track Via
                </div>
                <div class="col-sm-8">
                    <!--<select name="macropointLocationProviderId" [(ngModel)]="macropointLocationProviderId" class="form-select" (change)="macropointLocationProviderChange($event)" [required]="quoteOrderLine.isMacropointRequired == true">
                        <option *ngFor="let provider of macropointLocationProviders" value="{{provider.macropointLocationProviderId}}">{{provider.device}}</option>
                    </select>-->
                    <select name="macropointLocationProviderId" [(ngModel)]="macropointLocationProviderId" class="form-select" (change)="macropointLocationProviderChange($event)">
                        <option *ngFor="let provider of macropointLocationProviders" value="{{provider.macropointLocationProviderId}}">{{provider.device}}</option>
                    </select>
                </div>
            </div>
            <div class="row p-1" *ngIf="macropointLocationProviderDevice == 'VehicleID'">
                <div class="col-sm-4 fw-bold text-end">
                    Truck #
                </div>
                <div class="col-sm-8">
                    <select name="macropointGoodTruckID" [(ngModel)]="goodTruckEquipmentID" class="form-select" (change)="macropointGoodTruckChange($event)">
                        <option value="- Other -">- Other -</option>
                        <option *ngFor="let truck of macropointGoodTruckList" value="{{truck.equipmentID}}">{{truck.equipmentID}}</option>
                    </select>
                    <br />
                    <span *ngIf="goodTruckEquipmentID == '- Other -'">Other: <input type="text" [(ngModel)]="quoteOrderLine.truckNumber" /></span>
                </div>
            </div>
            <div class="row p-1" *ngIf="macropointLocationProviderDevice == 'VehicleID'">
                <div class="col-sm-4 fw-bold text-end">
                    Truck not found?
                </div>
                <div class="col-sm-8">
                    <button type="button" class="btn btn-secondary" (click)="getMacropointGoodTrucks(true)">Update Trucks</button>
                    <br />
                    Select "Other" if still not found and type the missing truck #.
                </div>
            </div>
            <div class="row p-1">
                <div class="col-sm-4 fw-bold text-end">
                    Begin Tracking
                </div>
                <div class="col-sm-8">
                    <kendo-datepicker name="beginTrackingDate" [(ngModel)]="beginTrackingDate" [format]="'MM/dd/yyyy'" [ngModelOptions]="{standalone: true}" [disabled]="true">
                    </kendo-datepicker>
                    <br />
                    <kendo-timepicker name="beginTrackingTime" [(ngModel)]="beginTrackingDate" [format]="'HH:mm'" [ngModelOptions]="{standalone: true}" [disabled]="true">
                    </kendo-timepicker>
                </div>
            </div>
            <div class="row p-1">
                <div class="col-sm-4 fw-bold text-end">
                    End Tracking
                </div>
                <div class="col-sm-8">
                    <kendo-datepicker name="endTrackingDate" [(ngModel)]="endTrackingDate" [format]="'MM/dd/yyyy'" [ngModelOptions]="{standalone: true}" [disabled]="true">
                    </kendo-datepicker>
                    <br />
                    <kendo-timepicker name="endTrackingTime" [(ngModel)]="endTrackingDate" [format]="'HH:mm'" [ngModelOptions]="{standalone: true}" [disabled]="true">
                    </kendo-timepicker>
                </div>
            </div>
            <div class="row p-1">
                <div class="col-sm-4 fw-bold text-end">
                    Location Updates
                </div>
                <div class="col-sm-8">
                    <!--<select name="trackingID" [(ngModel)]="macropointTrackInterval" class="form-select" (change)="validate(false)" [required]="quoteOrderLine.isMacropointRequired == true">
                        <option value=""></option>
                        <option *ngFor="let option of macropointTrackingOptions" value="{{option.macropointTrackingOptionID}}">{{option.locationProvider}}: {{option.locationUpdatesEvery}}</option>
                    </select>-->
                    <select name="trackingID" [(ngModel)]="macropointTrackInterval" class="form-select" (change)="validate(false)">
                        <option value=""></option>
                        <option *ngFor="let option of macropointTrackingOptions" value="{{option.macropointTrackingOptionID}}">{{option.locationProvider}}: {{option.locationUpdatesEvery}}</option>
                    </select>
                </div>
            </div>
            <!--<div class="row p-1">
            <div class="col-sm-4 fw-bold text-end">
                Event Updates
            </div>
            <div class="col-sm-8">
                <input type="checkbox" [(ngModel)]="macropointEventUpdates" style="transform:scale(1.5);" />
            </div>
        </div>-->
            <div class="row p-1">
                <div class="col-sm-4 fw-bold text-end">
                    Emails
                </div>
                <div class="col-sm-8">
                    <input class="form-control" type="text" [(ngModel)]="macropointEmails" />
                </div>
            </div>
        </div>
        <div class="row p-1">
            <div class="col-sm-4 m-2">
                <button class="btn btn-primary m-2" (click)="save()">Save</button>
                <button class="btn btn-secondary m-2" (click)="cancel()">Cancel</button>
            </div>
            <div class="col-sm-4">
                <ul class="alert alert-danger p-1" *ngIf="validationWarningList.length>0">
                    <li *ngFor="let warning of validationWarningList">{{warning}}</li>
                </ul>
            </div>
        </div>
    </div>
</kendo-expansionpanel>

<kendo-expansionpanel [title]="'Contract Documents'"
                      [subtitle]="''"
                      [expanded]="true"
                      *ngIf="carrierContract.masterOfferID > 0">
    <documents-form [recordTypeName]="'CarrierContract'" [recordID]="carrierContract.carrierContractID"></documents-form>
</kendo-expansionpanel>
